import { Button, StyledText } from "../../../components/common";
import { BackIcon, NoticeIcon } from "../../../components/svgs";
import sprialCalendar from "../../../components/images/spiral-calendar.png";
import { useTheme, useTrivia } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TriviaInfoModal from "./TriviInfoModal";
import { useState, useEffect } from "react";

const PlayTriviaModal = ({ onBackDropClick }) => {
  const { themeContext, theme } = useTheme();
  const [showTriviaInfo, setShowTriviaInfo] = useState();

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  let history = useHistory();

  const {
    activeTrivia,
    activeTriviaCategory,
    trivia,
    locationSelected,
    setActiveTrivia,
    setOpenPlayTriviaModal,
  } = useTrivia();

  useEffect(() => {
    if (trivia) {
      const currentTrivia = trivia
        .find((triv) => triv._id === activeTriviaCategory._id)
        ?.trivia?.find((triv) => triv._id === activeTrivia._id);
      setActiveTrivia(currentTrivia);
    }
  }, [trivia]);

  const { name: categoryName } = activeTriviaCategory || {};
  const {
    maxAttempts,
    userStats: { attempts },
    gameDuration,
  } = activeTrivia || {};

  return (
    <>
      <div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            top: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
          }}
          onClick={onBackDropClick}
        ></div>
        <div
          style={{
            position: "absolute",
            zIndex: 100,
            width: "100%",
            bottom: 0,
          }}
        >
          <div
            style={{
              boxSizing: "border-box",
              padding: "20px",
              height: "60%",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              marginTop: "70%",
              borderTopRightRadius: 15,
              borderTopLeftRadius: 15,
            }}
          >
            <div
              style={{
                width: 50,
                height: 8,
                backgroundColor: "#cbcbcb",
                borderRadius: 10,
              }}
            />
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                marginTop: 5,
                marginBottom: 5,
              }}
            >
              <div onClick={onBackDropClick}>
                <BackIcon />
              </div>
              <div>
                <NoticeIcon
                  onClick={() => setShowTriviaInfo(true)}
                  fill="black"
                />
              </div>
            </div>

            <StyledText style={{ fontSize: 20 }}>{categoryName}</StyledText>
            <img src={sprialCalendar} alt="calendar" />
            <StyledText
              style={{
                textAlign: "center",
                fontFamily: "MTNRegular",
                paddingInline: 15,
              }}
            >
              You have{" "}
              <span style={{ fontFamily: "MTNMedium" }}>
                {gameDuration || "90"} secs
              </span>{" "}
              to correctly answer all questions, Once you answer a question
              wrongly, it’s game over for you with{" "}
              <span style={{ fontFamily: "MTNMedium" }}>
                {maxAttempts - attempts} attempt(s) to play and win
              </span>
              .
            </StyledText>
            <Button
              style={{ backgroundColor: background, width: "80%" }}
              onClick={() => {
                if (maxAttempts - attempts > 0 && locationSelected) {
                  history.push("/trivia/play");
                  setOpenPlayTriviaModal(false);
                } else history.push("/trivia/trivia-category");
              }}
            >
              <StyledText color="white">
                {attempts ? "Try again" : "Play Trivia"}{" "}
              </StyledText>
            </Button>
          </div>
        </div>
      </div>
      {showTriviaInfo && (
        <TriviaInfoModal onBackButtonClick={() => setShowTriviaInfo(false)} />
      )}
    </>
  );
};

export default PlayTriviaModal;
